export default {
    deploy:"PROD"
}